import React from 'react';

const footerStyle = {
  marginTop: 32,
  textAlign: 'center',
  color: '#4e5980',
  fontSize: '0.8rem',
  letterSpacing: '1px',
  borderTop: '1px dashed #2f3763',
  paddingTop: 18,
};

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div style={footerStyle}>
      powered by wiki Game community @ {year}
    </div>
  );
};

export default Footer;
